module.exports = __webpack_public_path__ + "static/scale-model-of-grape-day-park-in-escondido-california-9aed7c4d0d4bacd9b4aac24e2393e650.png";